import type { HTMLAttributes } from 'react';

import { cn } from '@shared/lib/cn';

import {
  DIVIDER_ORIENTATION_CLASS,
  DIVIDER_TONE_CLASS,
  type DividerOrientation,
  type DividerTone,
} from './divider.constant';

export interface DividerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  /** Figma `orientation`. 기본 horizontal */
  orientation?: DividerOrientation;
  /** Figma `tone`. 기본 subtle */
  tone?: DividerTone;
  /** 꾸밈으로만 쓰면 true — 보조기기에서 숨긴다 */
  decorative?: boolean;
}

/** 내용을 나누는 1px 선 */
export function Divider({
  orientation = 'horizontal',
  tone = 'subtle',
  decorative = false,
  className,
  ...rest
}: DividerProps) {
  return (
    <div
      {...(decorative
        ? { 'aria-hidden': true }
        : { role: 'separator', 'aria-orientation': orientation })}
      data-orientation={orientation}
      data-tone={tone}
      {...rest}
      className={cn(
        'shrink-0',
        DIVIDER_ORIENTATION_CLASS[orientation],
        DIVIDER_TONE_CLASS[tone],
        className,
      )}
    />
  );
}
